import { render, staticRenderFns } from "./chat-message-read-status.vue?vue&type=template&id=651ca3e4&scoped=true"
import script from "./chat-message-read-status.vue?vue&type=script&lang=js"
export * from "./chat-message-read-status.vue?vue&type=script&lang=js"
import style0 from "./chat-message-read-status.vue?vue&type=style&index=0&id=651ca3e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ca3e4",
  null
  
)

export default component.exports